module.exports = "<icon-link icon=\"('clipboard')\" ng-click=\"$ctrl.copyToClipboard()\" uib-tooltip=\"{{$ctrl.tooltipText | translate}}\"></icon-link>";